'use es6';

import Raven from 'Raven';
export default (function (store) {
  return function (next) {
    return function (action) {
      next(action);
      Raven.setUser(store.getState());
    };
  };
});